import React,{Component} from 'react';
import './SignupCourier.css';
import HandleRes from '../Components/HandleRes/HandleRes';

import Navbar from '../Components/Navbar/Navbar'
import axios from 'axios'
import {LinkAPI} from '../../../API/API'
import Footer from '../Components/Footer/Footer'

class SignupCourier extends Component{
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            phone: "",
            password: "",
            confirmpassword: "",
            vehicletypeselect: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            confirmpasswordError: "",
            vehicletypeselectError:""
        } 
    } 
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };

    validate = () => {
        let nameError = "";
        let emailError = "";
        let phoneError = "";
        let passwordError = "";
        let confirmpasswordError="";
        let vehicletypeselectError=""
        if (this.state.name.length < 2||!isNaN(this.state.name)) {
            nameError = "ادخل الاسم صحيح";
        }
        if (this.state.password.length < 8) {
            passwordError = "يجب ان يكون كلمة السر اكبر من 8 حروف او ارقام";
        }
        if (  isNaN(this.state.phone)||this.state.phone.length < 10 ||this.state.phone.length > 11 ) {
            phoneError = "رقم هاتف خطاء";
        }
        
        if (this.state.vehicletypeselect==="") {
            vehicletypeselectError = "حدد نوع السيارة ";
        }
        if (this.state.vehicletypeselect!=="car"&&this.state.vehicletypeselect!=="van"&&this.state.vehicletypeselect!=="motorcycle") {
            vehicletypeselectError = "اختار وسيله من الوسائل  ";
        }
        
        if (this.state.confirmpassword.length < 8 || this.state.password !== this.state.confirmpassword) {
            confirmpasswordError = "كلمة السر غير مطابقه";
        }

        if (!this.state.email.includes("@")) {
            emailError = "بريد الكتروني غير صحبح";
        }

        if (nameError||emailError || passwordError||phoneError||confirmpasswordError||vehicletypeselectError) {
            this.setState({ nameError, emailError,  passwordError,vehicletypeselectError, confirmpasswordError,phoneError });
            return false;
        }

        return true;
    };

    handleSubmit = event => {
        event.preventDefault();
        const {name, phone, email, password,vehicletypeselect}=this.state
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/courier/signup`,{  name, phone:20+phone.replace(/^0+/, ''), email, password,vehicletypeselect},{
                headers:{ lang:"ar"}
               
              }).then(res =>{
                localStorage.setItem("userTokentConfirmData",res.data.courier.token)
                window.location.replace("/AR/Courier/ConfirmPhone");
             
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                }else if (error.response.data.message) {
                    this.setState({
                        nameError: "",
                        emailError: "",
                        phoneError: "",
                        passwordError: "",
                        confirmpasswordError: "",
                        vehicletypeselectError:"",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };
    render(){
        document.title ="kayn | سجل الان"; 
        document.getElementsByTagName("META")[1].content="كاين | سجل الان";
        document.documentElement.lang = 'ar';
        return(
            <div className="AppAR signup">
            <Navbar/>
            <div className='container'>
                <div className="SignupCourier  row">
                

                    <div className="col-md-6 form float-md-left  ">
                       <div className="contantform text-center p-4 ">
                            <h3 className="fontsize1 my-4">سجل الان </h3>
                            <p className="fontsize6 my-3">سجيل الان لمتابعة الوصول إلى الصفحات</p>
                            <form className="px-lg-5" onSubmit={this.handleSubmit}>
                                    <div className="form-group my-3">
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="الاسم" name="name" value={this.state.name} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.nameError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                        <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="البريد الالكتروني" name="email" value={this.state.email} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" ,}}>
                                            {this.state.emailError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3 nocounter">
                                    <div className="relative">
                                        <span className="codephone">+20</span>
                                        <input type="number" className={"form-control badge-pill p-3 " + (this.state.phoneError ? 'is-invalid' : '')} placeholder="رقم الهاتف" name="phone" value={this.state.phone} onChange={this.handleChange}required />
                                        </div>

                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.phoneError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                <select id="inputState" className="form-control  badge-pill " name="vehicletypeselect" value={this.state.vehicletypeselect} onChange={this.handleChange}required>
                                    <option value="">اختار</option>
                                    <option value="car">عربيه ملاكي </option>
                                    <option value="van">عربيه فان</option>
                                    <option value="motorcycle">موتوسكل</option>
                                </select>    
                                <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.vehicletypeselectError}
                                        </div>              
                            </div>
                                    <div className="form-group my-3">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" الرقم السري" name="password" value={this.state.password} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.passwordError}
                                        </div>
                                    </div>
                                    <div className="form-group my-3">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.confirmpasswordError ? 'is-invalid' : '')} placeholder="تاكيد الرقم السري" name="confirmpassword" value={this.state.confirmpassword} onChange={this.handleChange}required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.confirmpasswordError}
                                        </div>
                                    </div>
                                    <button type="submit"className="btn badge-pill btn-block shadow p-2 mb-2"  >تسجيل</button>
                                </form> 
                        
                       </div>
                    </div>
                    <div className="logoform col-6 d-flex align-content-end flex-wrap">
                    <div className="contantcover  p-5 mx-auto">
                            <p className="fontsize11 ml-5 mb-1 font-weight-bold bluecolor">التسليم الآمن ... بالتأكيد مكسب</p>
                    </div>
                </div>
                </div>
                
            </div>
            <Footer/>
            {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}
  
            </div>
        )
    }
}
export default SignupCourier;